export default function PageNotFound() {
  return (
    <>
      <h3 className="text-center mt-[10%] text-3xl">404 Page Not Found</h3>
    </>
  );
}
